import { CommonModule } from '@angular/common';
import { Component, ContentChild, ElementRef, EventEmitter, HostListener, Input, Optional, Output, Self, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { App } from '@df/core/app';
import { FileUploadService } from '@df/ui/form/file-upload/file-upload.service';
import { FormFieldAbstract } from '@df/ui/form/form-field.abstract';

@Component({
    selector: '[fileUpload]',
    templateUrl: './file-upload.html',
    styleUrls: ['file-upload.scss'],
    standalone: true,
    imports: [CommonModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FileUploadComponent,
            multi: true
        }
    ]
})
export class FileUploadComponent extends FormFieldAbstract {
    @Input()
    file: File | null = null;

    @Input()
    progress?: number;

    @Input()
    fileUpload?: any; // only for component selector

    /**
     * accept attr for the file input
     */
    @Input()
    accept?: string;

    @Output()
    fileChange = new EventEmitter<File | null>();

    @ContentChild('fileUploadTemplate')
    fileUploadTemplate?: TemplateRef<any>;

    @HostListener('change', ['$event.target.files'])
    emitFiles(event: FileList) {
        const file = event && event.item(0);
        this.onChange(file);
        this.file = file;
        this.fileChange.emit(file);
    }

    constructor(
        app: App,
        protected fileUploadService: FileUploadService,
        protected elementRef: ElementRef<HTMLInputElement>,
        @Optional() @Self() ngControl: NgControl
    ) {
        super(app, ngControl);
    }

    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param value
     */
    override writeValue(value: null) {
        super.writeValue(value);

        // clear file input
        this.elementRef.nativeElement.value = '';
        this.file = null;
    }
}
